import React from 'react';
import { Locked } from './Icons';
import bg from '../images/locked.png';

const LockedContent = ({ style, children }) => {
  return (
    <div className="locked-cont-wrapper" style={style}>
      <div className="post-img-cont ">
        <img className="post-content-img" src={bg} alt="" />
        <div className="locked-cont">
          {/* <Locked className=" mb-sm-4 mb-1 locked-icon " style={{ opacity: 0.2, fill: '#8a96a3' }} /> */}
          {children}
        </div>
      </div>
    </div>
  );
};

export default LockedContent;
